const initialState = {
  analytesList: [],
};

export const analytesReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "analytes")
    return action.execute(state);
  return state;
};
